// extracted by mini-css-extract-plugin
export var container = "certificate-card-module--container--gxJLZ";
export var imageBox = "certificate-card-module--image-box--7hLno";
export var ratio = "certificate-card-module--ratio--RIvNZ";